import { ColorOptions } from 'helpers/types';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import styles from './TestimonialSliderItem.module.scss';
import classNames from 'classnames';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import LeftButtonArrow from 'ui/icons/icon-left-button-arrow.svg';
import RightButtonArrow from 'ui/icons/icon-right-button-arrow.svg';

export interface UI_AuthorDetails {
	name: string;
	description: string;
	image?: {
		url: string;
		altText: string;
		fileType?: string;
	};
}

export interface UI_TestimonialSliderItemProps {
	heading: string;
	bgColor: ColorOptions;
	author?: UI_AuthorDetails;
	slideNumber?: number;
	onHandlePrevClick?: () => void;
	onHandleNextClick?: () => void;
	navigationPrevLabel?: string;
	navigationNextLabel?: string;
	isActive: boolean;
	globalTheme?: string;
	showAuthorImage?: boolean;
	disablePrevButton?: boolean;
	disableNextButton?: boolean;
}

export const UI_TestimonialSliderItem: React.FC<UI_TestimonialSliderItemProps> = ({
	heading,
	author,
	bgColor,
	slideNumber,
	onHandlePrevClick,
	onHandleNextClick,
	navigationPrevLabel,
	navigationNextLabel,
	isActive,
	globalTheme,
	showAuthorImage,
	disablePrevButton,
	disableNextButton,
}) => (
	<div
		className={classNames(
			styles.TestimonialSliderItem,
			styles[`TestimonialSliderItem___${bgColor}`],
			isActive ? styles.TestimonialSliderItem___active : '',
		)}
	>
		<UI_Container width="Standard">
			<div className={styles.TestimonialSliderItem_content}>
				<div className={styles.TestimonialSliderItem_heading}>
					<UI_Heading className={styles.TestimonialSliderItem_text} headingLevel="h2">
						{heading}
					</UI_Heading>

					{slideNumber > 1 && (
						<div className={styles.TestimonialSliderItem_navigation}>
							{globalTheme === 'kogp' ? (
								<>
									<UI_Button
										className={styles.TestimonialSliderItem_navigationPrev}
										onClick={onHandlePrevClick}
										style="noAnimation"
										ariaLabel={navigationPrevLabel}
										disabled={disablePrevButton}
									>
										<UI_Icon size="md">
											<LeftButtonArrow />
										</UI_Icon>
									</UI_Button>
									<UI_Button
										className={styles.TestimonialSliderItem_navigationNext}
										onClick={onHandleNextClick}
										style="noAnimation"
										ariaLabel={navigationNextLabel}
										disabled={disableNextButton}
									>
										<UI_Icon size="md">
											<RightButtonArrow />
										</UI_Icon>
									</UI_Button>
								</>
							) : (
								<>
									<UI_Button
										ariaLabel={navigationPrevLabel}
										onClick={onHandlePrevClick}
										style="arrowPrev"
										disabled={disablePrevButton}
										children={''}
									></UI_Button>
									<UI_Button
										ariaLabel={navigationNextLabel}
										onClick={onHandleNextClick}
										style="arrowNext"
										disabled={disableNextButton}
										children={''}
									></UI_Button>
								</>
							)}
						</div>
					)}
				</div>

				<div className={styles.TestimonialSliderItem_author}>
					{author && author.image && showAuthorImage && (
						<div className={styles.TestimonialSliderItem_authorImage}>
							<UI_Picture
								url={author.image.url}
								altText={author.name}
								imageCropping="cover"
								sizes="100px"
								fileType={author.image.fileType}
							/>
						</div>
					)}
					{author && author.name && <UI_Paragraph className={styles.TestimonialSliderItem_authorName}>{author.name}</UI_Paragraph>}
					{author && author.description && (
						<UI_Paragraph className={styles.TestimonialSliderItem_authorDescription}>{author.description}</UI_Paragraph>
					)}
				</div>
			</div>
		</UI_Container>
	</div>
);
